import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";

export const RangeNavigation = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  border: "1px solid lightgrey",
  padding: "4px 8px",
  width: "fit-content",
});

export const IconButton = styled("button")({
  background: "none",
  border: "none",
  padding: 0,
  cursor: "pointer",
});

export const ChartContainer = styled(Box)({
  width: "75%",
  paddingLeft: 170,
});